import { useQuery } from 'react-query';

import * as Api from '../api';
import * as Constants from '../constants';
import * as Mappers from '../mappers';

const useApplication = () => {
  const initialData = { item: Mappers.Application() };

  const { data = initialData, ...args } = useQuery(
    [Constants.ENTITY, 'application'],
    async () => {
      const { data } = await Api.Application();

      return {
        item: Mappers.Application(data && data.data)
      };
    },
    { initialData }
  );

  return { ...args, ...data };
};

export default useApplication;
